import { ViewUnitDto } from '../services/generated/models/ViewUnitDto';

export class ViewUnit implements ViewUnitDto {
  public id: number;
  public title: string | null;

  public get keyString() {
    return this.id.toString();
  }


  constructor(unit: ViewUnitDto) {
    this.id = unit.id;
    this.title = unit.title;
  }
}
